import { QRCodeSVG } from "qrcode.react";

type Props = {
    value: string;
    size?: number;
};

const QRCode = (props: Props) => {
    return <QRCodeSVG value={props.value} size={props.size ?? 256} />;
};

export { QRCode };
